import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export const RubricTagOverflowPill: React.FC<{
  overflowCount: number;
  tags: string[];
}> = ({ overflowCount, tags }) => {
  return (
    <div className="rounded-lg bg-gray-200 px-4 py-3 flex justify-center items-center w-fit max-w-32">
      <S2Typography
        variant="headline-6-alt"
        textColorVariant="gray-900"
        translatedContent={[
          { text: `+${overflowCount}`, tooltip: tags.join(', ') },
        ]}
      />
    </div>
  );
};
